import React, { useCallback, useEffect, useMemo, useState } from "react";
import { Col, Modal, Row } from "react-bootstrap";
import { Link, useHistory } from "react-router-dom";
import { FiEdit3, FiEye, FiInfo, FiPlusCircle } from "react-icons/fi";
import MainBreadcrumb from "app/views/custom/components/MainBreadcrumb";
import { useLocation } from "react-router-dom";
import {
  getMedicalStatusClass,
  MD_STATUS,
  medicalFilterFieldsAllMedical,
} from "./Constant";

import moment from "moment";

import {
  MEDICAL_STATUS_VIEW,
  MEDICAL_REPORT_STATUS,
  capitalLabel,
  MEDICAL_STATUS,
  MEDICAL_TYPE,
  MEDICAL_TYPE_OPTION,
  employeeFormLabel,
  medicalFilterFields,
  validateMedicalRowFilter,
} from "./Constant";

import {
  createMedical,
  downloadMedicalCertificate,
  getAllMedical,
  getMedicalList,
} from "app/_services/ehs/MedicalService";

import { TRAINEE_TYPE_OPTION } from "../TrainingManagement/CONSTANTS";
import { useContractorPerson, useEmployee } from "app/_helpers/hooks";
import { Validation } from "app/_helpers/validation/Validation";
import { CommmonService } from "app/_services/CommonService/CommonService";
import { isUserMedicalOfficer, isUserMM } from "../IncidentManagement/Helper";

import CustomTooltip from "app/Components/CommanComponents/CustomTooltip";

import { filterActionAdd } from "../TrainingManagement/Assign/ReducerForAssign";
import { useDispatch, useSelector } from "react-redux";
import SearchBootstrapTable from "app/Components/BootstrapTable/SearchBootstrapTable";
import BackBtn from "app/Components/CommanComponents/BackBtn";
import AddToBatchModalMedical from "./Component/AddToBatchModalMedical";
import FormSelect from "app/Components/_form/FormSelect/FormSelect";
import { downloadFileByURL } from "app/_helpers/reactHelper";
import { URL_CONFIG } from "app/_constants/Config/URL_CONFIG";
import { DDMMYYYYFormat } from "app/_helpers/dateHelper";
import FilterBtn from "app/Components/CommanComponents/FilterBtn";
import { useForm } from "app/_helpers/hooks";
import MedicalFilters from "./Component/MedicalFilters";
import { ACTIVE_MODULE } from "app/_constants/constant";
import { capitalizeName } from "app/_helpers/helper";
import NetZeroLoader from "app/views/custom/components/Loader/NetZeroLoader";
import MedicalFiltersAll from "./Component/MedicalFilterAll";

const initialFilter = { medicalStatus: "all", medicalResult: "all", medicalTestType: "" };

function ViewMedicalData({ isPmeSchedule = false }) {
  //get status state
  const filterStatus = useSelector((state) => state.filterReducerTraining);
  const [initialTableList, setInitialTableList] = useState([]);

  const [tableVFLList, setTableVFLList] = useState([]);

  const [filter, setFilter] = useState(
    !filterStatus?.medicalFilter
      ? { ...initialFilter }
      : { ...filterStatus?.medicalFilter }
  );
  const [showModal, setShowModal] = useState(false);
  const [showFilter, setShowFilter] = useState(false);
  const [filterForm, setFilterForm] = useState({});
  const [loading, setLoading] = useState(true);
  const location = useLocation();

  const dispatchFunction = useDispatch();

  console.log("location", location);

  //
  const onReset = () => setFilterForm({ formA: "" });

  const onChange = ({ target: { name, value } }) => {
    setFilterForm((prev) => {
      if (name === "medicalAssigneeTypeView") {
        prev.assigneeName = "";
        prev.assigneeID = "";
      }
      return { ...prev, [name]: value };
    });
  };

  const initialData = useCallback(async () => {
    const fetchData = async () => {
      try {
        let response = await getMedicalList("activeAssigneeMedical");
        if (!response?.data) {
          setLoading(false);
          return;
        }
        setInitialTableList(
          Array.isArray(response?.data)
            ? response?.data
                .filter(
                  (obj) =>
                    (isPmeSchedule && obj?.medicalTestType === "pme") || !isPmeSchedule
                )
                .map((data, index) => ({
                  ...data,
                  locationName: data?.ehsSite ? data?.ehsSite?.name : "",
                  sid: index + 1,
                }))
            : []
        );
        setLoading(false);
      } catch (error) {
        console.error("Error fetching data:", error);
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  useEffect(() => {
    dispatchFunction(filterActionAdd({ medicalFilter: filter }));
  }, [dispatchFunction, filter]);

  const tableToolbarView = () =>
    !isPmeSchedule ? (
      <CustomTooltip tooltip={"Assign Training"}>
        <span
          className="icons btn-icon font-20 text-cyanBlue"
          onClick={() => setShowModal(true)}
        >
          <FiPlusCircle />
        </span>
      </CustomTooltip>
    ) : null;

  const downloadPdf = async (id) => {
    downloadFileByURL(
      URL_CONFIG.DEV_URL +
        "global-configuration/ehs-module/download-medical-certificate/" +
        id,
      `medical-certificate-${new Date().toISOString()}.pdf`
    );
  };

  // ************Use Memo ***************
  const sortableColumn = useMemo(() => {
    const column = [
      {
        dataField: "sid",
        text: "S.No.",
        sort: true,
      },
      {
        dataField: "locationName",
        text: "Location",
        sort: true,
      },
      {
        dataField: "medicalTestTypeView",
        text: "Exam",
        sort: true,
      },
      {
        dataField: "medicalAssigneeTypeView",
        text: "Staff Type",
        sort: true,
      },
      {
        dataField: "assigneeName",
        text: "Name",
        sort: true,
        formatter: (status, row) => {
          return <div>{capitalizeName(row?.assigneeName)}</div>;
        },
      },
      {
        dataField: "assigneeID",
        text: "ID",
        sort: true,
      },
      {
        dataField: "formA",
        text: "Form A",
        sort: true,
      },
      {
        dataField: "ehsSite.name",
        text: "Mines name",
        sort: true,
      },
      {
        dataField: "medicalStatusView",
        text: "Status",
        sort: true,
        formatter: (status, row) => {
          return (
            <div className={getMedicalStatusClass(status)}>{capitalLabel(status)}</div>
          );
        },
      },
      {
        dataField: "lastIMEDate",
        text: "IME Date",
        sort: true,
        //formatter: (date, row) => moment(row?.examDate).format("DD-MM-YYYY"),
        formatter: (date, row) =>
          row?.lastIMEDate ? DDMMYYYYFormat(row?.lastIMEDate) : row?.lastIMEDate,
      },
      {
        dataField: "lastPMEDate",
        text: "Last PME Date",
        sort: true,
        //formatter: (date, row) => moment(row?.examDate).format("DD-MM-YYYY"),
        formatter: (date, row) =>
          row?.lastPMEDate ? DDMMYYYYFormat(row?.lastPMEDate) : row?.lastPMEDate,
      },
      {
        dataField: "nextPMEDate",
        text: "Next PME Date",
        sort: true,
        //formatter: (date, row) => moment(row?.examDate).format("DD-MM-YYYY"),
        formatter: (date, row) =>
          row?.nextPMEDate ? DDMMYYYYFormat(row?.nextPMEDate) : row?.nextPMEDate,
      },
      {
        dataField: "medicalResult",
        text: "Report Status",
        sort: true,
        formatter: (status, row) => {
          return (
            <div className={getMedicalStatusClass(status)}>{capitalLabel(status)}</div>
          );
        },
      },
      {
        dataField: "certificateId",
        text: "Certificate",
        sort: true,
        formatter: (id, row) => {
          return (
            <div className="actionIconsGroup">
              {row?.medicalStatus === MEDICAL_STATUS.approved &&
                row?.medicalResult === MEDICAL_REPORT_STATUS.fit &&
                isUserMedicalOfficer() && (
                  <CustomTooltip tooltip={"Certificate"}>
                    <span
                      // href={
                      //   (row?.medicalTestType.toLowerCase() === "sme"
                      //     ? "/health-safety-and-environment/medical-management/sme-certificate/"
                      //     : "/health-safety-and-environment/medical/certificate/") +
                      //   row?.id
                      // }
                      // target="_blank"
                      // rel="noopener noreferrer"
                      onClick={() => downloadPdf(row?.id)}
                      className="icons text-cyanBlue"
                    >
                      <FiInfo style={{ color: "rgb(21 239 21)" }} />
                    </span>
                  </CustomTooltip>
                )}
            </div>
          );
        },
      },
      {
        dataField: "completionDate",
        text: "Exam Date",
        sort: true,
        //formatter: (date, row) => moment(row?.examDate).format("DD-MM-YYYY"),
        formatter: (date, row) =>
          row?.completionDate ? DDMMYYYYFormat(row?.completionDate) : row?.completionDate,
      },
      // {
      //   dataField: "dueDateView",
      //   text: "Due Date",
      //   sort: true,
      //   formatter: (date) => moment(date).format("DD-MM-YYYY"),
      // },
      {
        dataField: "create",
        text: "Action",
        formatter: (rowContent, row) => {
          return (
            <div className="actionIconsGroup">
              <CustomTooltip tooltip={"View"}>
                <Link
                  to={"/health-safety-and-environment/medical/view/" + row.id}
                  className="icons text-cyanBlue"
                >
                  <FiEye />
                </Link>
              </CustomTooltip>
            </div>
          );
        },
      },
    ];

    return column;
  }, []);

  const finalSortableColumn = useMemo(() => {
    return sortableColumn.filter((obj) => {
      return (
        (isPmeSchedule &&
          obj.dataField !== "medicalTestTypeView" &&
          obj.dataField !== "completionDate" &&
          obj.dataField !== "medicalResult") ||
        (!isPmeSchedule &&
          obj.dataField !== "lastPMEDate" &&
          obj.dataField !== "dueDate" &&
          obj.dataField !== "lastIMEDate")
      );
    });
  }, [isPmeSchedule, sortableColumn]);

  // ************Use Effect ***************

  useEffect(() => {
    initialData();
  }, [initialData]);

  useEffect(() => {
    setTableVFLList(
      initialTableList?.filter?.((obj) => {
        return validateMedicalRowFilter(obj, filterForm);
      })
    );
  }, [filterForm, initialTableList]);

  const tableToolbarBeforeView = () =>
    showFilter && (
      <MedicalFilters
        fields={medicalFilterFields}
        setForm={setFilterForm}
        form={filterForm}
        onChange={onChange}
        onReset={onReset}
        isPmeSchedule={isPmeSchedule}
      />
    );

  return (
    <>
      <MainBreadcrumb
        routeSegments={[
          { name: "Health Safety And Environment", path: "#" },
          {
            name: "Personnel Health Management",
            path: "/health-safety-and-environment/medical",
          },
          { name: isPmeSchedule ? "View PME Schedule" : "View Medical Data" },
        ]}
        module={ACTIVE_MODULE.personnelHealthManagement}
      />
      <br />
      <br />
      <div className="healthSafetyEnvironmentWrapper">
        <div>
          <div className="card p-4 mb-4 overflow-visible">
            <div className="simple-card-title">
              <h3 className="text-capitalize mb-1">
                {isPmeSchedule ? "View PME Schedule" : "View Medical Data"}
              </h3>
              <FilterBtn setShowFilter={setShowFilter} />

              <BackBtn url={`/health-safety-and-environment/medical`} />
            </div>

            <div className="healthSafetyEnvironmentWrapper EHS_module_tabber mb-3">
              <div className="hseMenuLinks card">
                {
                  <Link
                    to={"/health-safety-and-environment/medical/view-medical-data"}
                    className={`pointer${
                      location?.pathname.split("/")?.includes("view-medical-data")
                        ? " active"
                        : ""
                    }`}
                  >
                    Medical Data - Workflow Generated
                  </Link>
                }

                {
                  <Link
                    to={"/health-safety-and-environment/medical/view-done-medical-data"}
                    className={`pointer${
                      location?.pathname.split("/")?.includes("view-done-medical-data")
                        ? " active"
                        : ""
                    }`}
                  >
                    Medical Data - All
                  </Link>
                }
              </div>
            </div>

            {!loading ? (
              <>
                <SearchBootstrapTable
                  searchKey={"ViewMedicalDataDesktopSearch"}
                  data={tableVFLList.map((d, idx) => ({ ...d, sid: idx + 1 }))}
                  columns={finalSortableColumn}
                  tableToolbarView={tableToolbarView}
                  tableBeforeSearch={tableToolbarBeforeView}
                  tableKey="ViewMedicalData"
                />
              </>
            ) : (
              <NetZeroLoader />
            )}
          </div>
        </div>

        <AddToBatchModalMedical show={showModal} onHide={setShowModal} />
      </div>
    </>
  );
}

export default ViewMedicalData;
